import { useContext } from "react";
import {
  LegalAcknowledgementContext,
  TLegalAcknowledgementContextType,
} from "./LegalAcknowledgementContext";

export const useLegalAcknowledgement = (): TLegalAcknowledgementContextType => {
  const context = useContext(LegalAcknowledgementContext);

  if (context === undefined) {
    throw new Error(
      "useLegalAcknowledgement must be used within a LegalAcknowledgementProvider",
    );
  }

  return context;
};
